import type { SavedFilter } from '@/entities/saved-filter';

import type { SavedFilterResponse } from './savedFilters.types';

export const normalizeSavedFiltersResponse = (
  data: Record<string, SavedFilterResponse>
): SavedFilter[] => Object.entries(data).map(([id, value]) => ({ id, ...value }));
